<template>
  <v-row>
    <v-col v-for="team in teams" :key="team.id" md="3">
      <v-card class="dept-cards dt-border pl-3 pr-3 pt-4" flat height="265">
        <v-container class="d-flex flex-column" height="100%" style="height:100%">
          <h3>{{team.name}}</h3>
          <v-card-actions class="d-block mt-auto">
            <p class="mb-2 team">Team</p>
            <div v-if="team.members.length > 0" class="mb-7">
              <v-avatar class="avatar" size="40">
                <img
                  src="https://cdn.vuetifyjs.com/images/john.jpg"
                  alt="John"
                />
              </v-avatar>
              <v-avatar class="avatar" size="40">
                <img
                  src="https://cdn.vuetifyjs.com/images/john.jpg"
                  alt="John"
                />
              </v-avatar>
              <v-avatar class="avatar" size="40">
                <img
                  src="https://cdn.vuetifyjs.com/images/john.jpg"
                  alt="John"
                />
              </v-avatar>
              <span>&nbsp; +13</span>
            </div>
            <div v-else>
              <p>No member added yet</p>
            </div>
            <center>
                <v-btn v-if="team.members.length > 0" depressed color="transparent" @click="view(team.id)" class="action-btn justify-center mb-0">View</v-btn>
                <addtoteam-modal v-else :team="team" @add-member="getTeams"/>
                <!-- <v-btn v-else depressed color="transparent" class="action-btn justify-center mb-0">Add Admin</v-btn> -->
            </center>  
          </v-card-actions>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import * as ROUTES from "@/http/routes.js";
import AddtoteamModal from "../components/add-to-team-modal.vue"
export default {
  props:{
    teams:{
      type:Array
    }
  },
  components:{
    AddtoteamModal
  },
  data: () => ({

  }),
  methods:{
    view(id){
      this.$router.push({
        path:`/workforce/team/${id}`
      })
    }
    ,
    getTeams(){
      this.$emit("add-member");
    }
  }
  
};
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";

.dept-cards{
    background: $Dtunes-offwhite;
    h3,span{
        color: $Dtunes-text;
    }
    h3{
        font-weight: 500;
        font-size: 17px;
    }
    .team{
        color: $Dtunes-grey;
        font-size: 14px;
    }
    .avatar{
        margin-left: -10px;
        border: 2px solid #fff;

        &:first-child{
        margin-left: 0px;
    }
    }
    
    .action-btn{
        color: $Dtunes-orange;
    }
}
</style>